const STORAGE_KEY = 'BAO_authentic_viewed_ids'

function getStorage () {
  return JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || []
}

function hasViewedAuthentic (id) {
  return getStorage().includes(id.toString())
}

function storeAuthenticViewed (id) {
  const ids = getStorage()
  const stringId = id.toString()

  if (!ids.includes(stringId)) {
    ids.push(stringId)
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(ids))
  }
}

function removeAuthenticViewed (id) {
  const stringId = id.toString()
  const ids = getStorage().filter(storedId => storedId !== stringId)

  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(ids))
}

class AuthenticTagTracking extends window.BAO.CustomElement() {
  setupListeners () {
    this.listeners.add(
      window.BAO.eventBus,
      window.BAO.EVENTS.DRAWER.OPENED,
      this.trackAuthenticInfoDrawer.bind(this),
    )
  }

  trackAuthenticInfoDrawer (event) {
    const { key, e } = event.detail

    if (key !== 'authentic-info') return

    if (e?.target?.closest('authentic-tag') !== this) return

    const productTitle = this.dataset.ga4ProductTitle || ''
    const productId = this.dataset.ga4ProductId || ''

    if (!productId) return

    window.dataLayer.push({
      event: 'authentic_info_drawer_open',
      item_title: productTitle,
      item_id: productId,
    })

    storeAuthenticViewed(productId)
  }
}

if (!customElements.get('authentic-tag')) {
  customElements.define('authentic-tag', AuthenticTagTracking)

  window.BAO.eventBus.addEventListener(
    window.BAO.EVENTS.PUSH_CART.BEFORE_ADD_FROM_FORM,
    event => {
      const { formData } = event.detail
      const variantId = formData.get('product-id')

      if (!variantId) return

      if (hasViewedAuthentic(variantId)) {
        formData.append('properties[authentic_viewed]', 'true')
      }
    },
  )

  window.BAO.eventBus.addEventListener(
    window.BAO.EVENTS.PUSH_CART.AFTER_ADD_FROM_FORM,
    event => {
      const productId = event.detail.state?.product_id
      const productTitle = event.detail.state?.product_title || ''

      if (!productId) return

      if (hasViewedAuthentic(productId)) {
        window.dataLayer.push({
          event: 'authentic_add_to_cart',
          item_id: productId.toString(),
          item_title: productTitle,
        })

        removeAuthenticViewed(productId)
      }
    },
  )
}
